import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const Automotive = () => {
  return <PageTemplate title="Automotive Solutions" subtitle="Connected Vehicle Technology" breadcrumb="Engineering > Automotive"><div className="content-section"><p>Automotive software, connected vehicle systems, and autonomous technology.</p></div></PageTemplate>;
};
export default Automotive; 